// extracted by mini-css-extract-plugin
export default {"header":"Header_header__teQdB","calculation":"Header_calculation__fuzws","result":"Header_result__lxsjQ"};